'use client';
import { HStack, VStack, NumberInput, Text } from '@chakra-ui/react';
import { USDCIcon } from '@/components/ui/svgs/usdc';
import { useErc20TokenBalance } from '@/lib/hooks/walletHooks/useErc20Token';
import { USDC_CONTRACT } from '@/lib/config/contracts';
import { arbitrum } from 'viem/chains';
import { useAccount } from 'wagmi';
type AmountInputAreaProps = {
  amount: string;
  setAmount: (amount: string) => void;
  balance: string;
};

export const AmountInputArea = ({
  amount,
  setAmount,
  balance,
}: AmountInputAreaProps) => {
  const { address } = useAccount();
  const tokenRes = useErc20TokenBalance({
    userAddress: address,
    contractAddress: USDC_CONTRACT[arbitrum.id],
  });
  return (
    <HStack
      w="full"
      justify="space-between"
      border="1px solid #FFFFFF26"
      rounded={8}
      p={4}
    >
      <VStack align={'start'} gap={2}>
        <NumberInput.Root>
          <NumberInput.Input
            border="none"
            _focusVisible={{ outline: 'none' }}
            color="white"
            fontSize={'32px'}
            lineHeight={1.2}
            placeholder="0.00"
            value={amount}
            onChange={(e) => {
              if (Number(e.target.value) <= Number(balance)) {
                setAmount(e.target.value);
              } else {
                setAmount(balance);
              }
            }}
          />
        </NumberInput.Root>
        <Text
          fontWeight={300}
          fontSize={'xs'}
          lineHeight={1.2}
          color={'white/60'}
        >
          ${amount}
        </Text>
      </VStack>
      <HStack gap={4} align={'start'}>
        {/* <VStack py={'6px'}>
          <HStack
            rounded={4}
            bg="fixed.long/10"
            px={2}
            py={'3px'}
            color="fixed.long"
            fontWeight={500}
            fontSize={'xs'}
            lineHeight={'16px'}
            cursor={'pointer'}
            onClick={() => setAmount(balance)}
          >
            MAX
          </HStack>
        </VStack> */}
        <VStack align="end" gap="14px">
          <HStack gap={'6px'} rounded={8} bg="white/8" py="6px" px="10px">
            <USDCIcon />
            <Text fontSize="sm" fontWeight={500} lineHeight={'16px'}>
              USDC
            </Text>
          </HStack>
          <HStack gap={2}>
            <HStack
              rounded={4}
              bg="fixed.long/10"
              px={2}
              py={'3px'}
              color="fixed.long"
              fontWeight={500}
              fontSize={'xs'}
              lineHeight={'16px'}
              cursor={'pointer'}
              onClick={() => setAmount(balance)}
            >
              MAX
            </HStack>
            <Text
              fontWeight={300}
              fontSize={'xs'}
              lineHeight={1.2}
              color={'white/60'}
            >
              Balance:
            </Text>
            <Text
              fontWeight={300}
              fontSize={'xs'}
              lineHeight={1.2}
              color={'white'}
            >
              ${balance}
            </Text>
          </HStack>
        </VStack>
      </HStack>
    </HStack>
  );
};
